import React from "react";

export default function WhyHire() {
    return (
        <>
            <section className="pt-20 pb-20 bg-light">
                <div className="container px-1">
                    <img src="/why_hire.webp" alt="Tarif Overseas Headquarters" className="img-fluid" />
                </div>
            </section>
        </>
    );
}